export default "__VITE_ASSET__CElN8mOI__"